export const scenarioQueryKeys = (scenarioId) => ({
  scenario: `${scenarioId}_scenario`,
  assets: `${scenarioId}_assets`,
  forecasts: `${scenarioId}_forecast`,
  cashflowEvents: `${scenarioId}_cashflowEvents`,
  liabilities: `${scenarioId}_liabilities`,
  notes: `${scenarioId}_notes`,
  riskProfile: `${scenarioId}_riskProfile`,
  budget: `${scenarioId}_budget`,
  fna: `${scenarioId}_fna`,
  assetAllocation: `${scenarioId}_assetAllocation`,
  riskProducts: `${scenarioId}_riskProducts`,
})
